import gsap from 'gsap'
import { q1O } from '../util/nE'

class PromoBanner {
  constructor ($el) {
    this.el = $el
    this.closeButton = this.el.querySelector('.btn--close')
    this.storageKey = 'promoBannerShown'
  }

  init () {
    if (sessionStorage.getItem(this.storageKey)) {
      this.el.style.display = 'none'
      return
    }

    this.buildTimelineIn()

    sessionStorage.setItem(this.storageKey, 'true')
  }

  buildTimelineIn () {
    const tl = gsap.timeline({
      defaults: {
        ease: (t) => {
          return q1O(t)
        },
        duration: 0.7,
      },
      delay: 5,
    })

    tl.fromTo(this.el, {
      autoAlpha: 0,
      height: 0,
    }, {
      autoAlpha: 1,
      height: 'auto',
    })

    this.closeButton.addEventListener('click', () => {
      tl.reverse()
    })
  }

  destroy () {
    // You might want to clean up event listeners here
  }
}

export default PromoBanner



//////////////////
// WEBPACK FOOTER
// ./scripts/components/PromoBanner.js
// module id = 64
// module chunks = 0